import React, { useRef, useState } from "react";
import Icon from "./Icon";
import { useI18n } from "../i18n";
import { C, R, S } from "../theme";

async function compress(file) {
  const dataUrl = await new Promise((res) => {
    const r = new FileReader();
    r.onload = () => res(r.result);
    r.readAsDataURL(file);
  });
  const img = await new Promise((res) => {
    const i = new Image();
    i.onload = () => res(i);
    i.src = dataUrl;
  });
  const max = 1200;
  let { width, height } = img;
  if (width > max || height > max) {
    if (width > height) { height = (height * max) / width; width = max; }
    else { width = (width * max) / height; height = max; }
  }
  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  canvas.getContext("2d").drawImage(img, 0, 0, width, height);
  return canvas.toDataURL("image/jpeg", 0.7);
}

export default function PhotoButton({ value, onCapture, required, allowGallery, testID }) {
  const { t: tr } = useI18n();
  const camRef = useRef(null);
  const galRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const b64 = await compress(file);
      onCapture(b64);
    } finally {
      setBusy(false);
      e.target.value = "";
    }
  };

  return (
    <div>
      <input ref={camRef} type="file" accept="image/*" capture="environment" onChange={handle} style={{ display: "none" }} />
      <input ref={galRef} type="file" accept="image/*" onChange={handle} style={{ display: "none" }} />
      {value ? (
        <div style={{ position: "relative" }}>
          <img src={value} alt="evidence" style={{ width: "100%", height: 180, objectFit: "cover", borderRadius: R.md }} />
          <button
            data-testid={testID ? `${testID}-retake` : "photo-retake"}
            className="pressable"
            onClick={() => camRef.current.click()}
            style={{ position: "absolute", top: 8, right: 8, background: "rgba(0,0,0,0.6)", borderRadius: R.pill, padding: "6px 12px", color: C.text, fontWeight: 700, display: "flex", gap: 6, alignItems: "center" }}
          >
            <Icon name="camera" size={16} color={C.text} /> {tr("photo.retake")}
          </button>
        </div>
      ) : (
        <div style={{ display: "flex", gap: S.sm }}>
          <button
            data-testid={testID || "photo-capture"}
            className="pressable"
            onClick={() => camRef.current.click()}
            style={{ flex: 1, minHeight: 56, borderRadius: R.md, background: C.card2, border: `2px solid ${required ? C.red : C.borderStrong}`, color: C.text, fontWeight: 800, display: "flex", gap: S.sm, alignItems: "center", justifyContent: "center" }}
          >
            <Icon name="camera" size={22} color={required ? C.red : C.amber} />
            {busy ? "…" : tr("photo.take")}
          </button>
          {allowGallery && (
            <button
              data-testid="photo-gallery"
              className="pressable"
              onClick={() => galRef.current.click()}
              style={{ minHeight: 56, borderRadius: R.md, background: C.card2, border: `1px solid ${C.borderStrong}`, color: C.amber, fontWeight: 800, padding: `0 ${S.lg}px` }}
            >
              {tr("photo.gallery")}
            </button>
          )}
        </div>
      )}
    </div>
  );
}
